import { Stack } from "@fluentui/react";
import React from "react";
import { Callout, CalloutProps } from "../../../../Callout/Callout";
import { StopPropagation } from "../../../../StopPropagation/StopPropagation";

export interface DrawerHeaderCalloutProps {
    /**
     * Callout to render in the drawer header
     */
    readonly calloutProps: CalloutProps;
}

export const DrawerHeaderCallout: React.FC<DrawerHeaderCalloutProps> = ({
    calloutProps
}) => {

    return (
        <Stack horizontalAlign="center">
            <StopPropagation>
                <Callout {...calloutProps}>
                    {calloutProps.children}
                </Callout>
            </StopPropagation>
        </Stack>
    );
};
